import React, { Component } from 'react';
import './styles.scss';
import validator from 'validator';
import { Form, FormTitle, FormContent, FormInput, FormButton } from '../Form';
import CreateUserMutation from '../../mutations/CreateUser';

const initialState = {
	firstName: '',
	lastName: '',
	username: '',
	password: ''
};
class AddPlayerForm extends Component {
	constructor(props) {
		super(props);
		this.state = initialState;
	}
	createUser(createUserMutation) {
		const { onUserCreated } = this.props;
		const data = { ...this.state, roles: ['player'] };
		createUserMutation({ variables: { data } }).then(mutation => {
			onUserCreated(mutation.data.createUser);
		});
	}
	render() {
		const { firstName, lastName, username, password } = this.state;
		const disabled =
			!firstName ||
			!lastName ||
			!username ||
			!password;
		return (
			<CreateUserMutation>
				{createUserMutation => (
					<Form className="AddPlayerForm" style={{ height: 'auto' }}>
						<FormTitle>Add User</FormTitle>
						<FormContent>
							<FormInput
								onChange={e => this.setState({ firstName: e.target.value })}
								type={'text'}
								placeholder={'First Name'}
								value={firstName}
							/>
							<FormInput
								onChange={e => this.setState({ lastName: e.target.value })}
								type={'text'}
								placeholder={'Last Name'}
								value={lastName}
							/>
							<FormInput
								onChange={e => this.setState({ username: e.target.value })}
								type={'username'}
								placeholder={'Username (Bocconi ID)'}
								value={username}
							/>
							<FormInput
								onChange={e => this.setState({ password: e.target.value })}
								type={'text'}
								placeholder={'Password'}
								value={password}
							/>
							<FormButton
								disabled={disabled}
								onClick={() => this.createUser(createUserMutation)}
							>
								Create New
							</FormButton>
						</FormContent>
					</Form>
				)}
			</CreateUserMutation>
		);
	}
}

export default AddPlayerForm;
